import {utilHelper} from "../../_helpers";
import {jsonProductPromotionMockResponse} from "./mockups";

const relativeUrl = 'api/productPromotion'


export const productPromotionService = {
    search,
    saveItem,
    updateItem,
    deleteItem,
    syncFirebase,
    listChilds,
    addChild,
    removeChild,
    sync
};

function search(offset, max, data) {
    // return new Promise((resolve, reject) => {
    //     resolve(jsonProductPromotionMockResponse);
    // });

    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', { data, showAlert: false})
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data });
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data })
}

function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE', {})
}

function syncFirebase() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncFirebase`, 'GET', {  })
}

function listChilds(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/listChilds`, 'POST', { data, showAlert: false});
}

function addChild(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/add`, 'POST', { data });
}

function removeChild(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/remove`, 'POST', { data });
}

function sync(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getPromoProducts`, 'POST', { data });
}